import React, { useState, useEffect, useRef } from 'react';
import { useContext } from 'react';
import {
	Modal,
	Input,
	Button,
	Menu,
	Dropdown,
	Tooltip,
	Image,
	Row,
	Col,
} from 'antd';
import filterContext from '../context/filters/filterContext';
import '../styles/chatDetails.css';
import { BiArrowBack } from 'react-icons/bi';
import { BsDownload } from 'react-icons/bs';
import { AiOutlineRight } from 'react-icons/ai';
import Chat from './Chat';
import '../styles/chats.css';
import '../styles/leftMenu.css';
import { FaDownload } from 'react-icons/fa';
import { BsTelephonePlusFill } from 'react-icons/bs';
// import ProfilePic from '../../../components/profile/DisplayPicture';

import { DownOutlined } from '@ant-design/icons';
import RedFlagResolution from './RedFlagResolution';

import { useSelector } from 'react-redux';
import moment from 'moment';
import doc from './doctype.png';
// import { apiBaseUrl } from 'utils/config';
import RoundedBtn from './Common/RoundedBtn';

const Groupinformation = () => {
	const [count, setcount] = useState(0);
	const [addParticipantsModal, setAddParticipantsModal] = useState(false);
	const [modalUsers, setModalUsers] = useState([]);
	const [searchQuery, setSearchQuery] = useState('');
	const [selectedUserObj, setSelectedUserObj] = useState({});
	const [filteredUsers, setFilteredUsers] = useState([]);
	const [idd, setIdd] = useState('');
	const [isAdmin, setIsAdmin] = useState(false);
	const [editGrpInfoModal, setEditGroupInfoModal] = useState(false);
	const [fullscreenVisible, setFullscreenVisible] = useState(false);
	const [selectedImage, setSelectedImage] = useState('');

	const {
		setpimgLink,
		convId,
		setConveresationId,
		conversationdata,
		setConversationdata,
		fetchConversation,
		description,
		usersOfParticularGroup,
		setusersOfParticularGroup,
		allUsers,
		selectedUser,
		setSelectedUser,
		addUserToGrp,
		displayedUsersOfGroup,
		setDisplayedUsersOfGroup,
		removeUserFromGrp,
		isGrpEdited,
		setIsGroupEdited,
		makeGroupAdmin,
		removeAsAdmin,
		createdAt,
		createdBy,
		showRedFlagResolution,
		setShowRedFlagResolution,
		updateConversationDescription,
		previewMedia,
		setPreviewMedia,
	} = useContext(filterContext);

	const { namePerson, pimgLink, togChat, settogChat } = useContext(
		filterContext
	);
	const handletoggle = event => {
		settogChat(current => !current);
	};

	const inputString = description;
	const separatedArray = inputString?.split('--###--');
	const [groupInfo, setGroupInfo] = useState({
		uniqueCode:
			separatedArray?.length > 1
				? separatedArray[0]?.split(':')[1].trim()
				: separatedArray[0],
		userName:
			separatedArray?.length > 1 ? separatedArray[1].split(':')[1].trim() : '-',
		board:
			separatedArray?.length > 2
				? separatedArray[2]
						.split(':')[1]
						.trim()
						.slice(1, separatedArray[2].split(':')[1].trim().length - 1)
				: '-',
		standard:
			separatedArray?.length > 3
				? separatedArray[3]
						.split(':')[1]
						.trim()
						.slice(1, separatedArray[3].split(':')[1].trim().length - 1)
				: '-',
		sections:
			separatedArray?.length > 4
				? separatedArray[4]
						.split(':')[1]
						.trim()
						.slice(1, separatedArray[4].split(':')[1].trim().length - 1)
				: '-',
		subject:
			separatedArray?.length > 5
				? separatedArray[5]
						.split(':')[1]
						.trim()
						.slice(1, separatedArray[5].split(':')[1].trim().length - 1)
				: '-',
	});
	const [previewMediaPage, setPreviewMediaPage] = useState(false);
	const [previewMediaContent, setPreviewMediaContent] = useState('media');
	const userSelector = state => state.user;
	const user = useSelector(userSelector);
	let mediaCount = 0;
	let docsCount = 0;

	useEffect(() => {
		const debounceSearch = setTimeout(() => {
			const lowerCaseQuery = searchQuery.toLowerCase();
			const filteredModalUsers = modalUsers.filter(user =>
				user.name.toLowerCase().includes(lowerCaseQuery)
			);
			setFilteredUsers(filteredModalUsers);
		}, 300);
		return () => {
			clearTimeout(debounceSearch);
		};
	}, [searchQuery, modalUsers]);

	const handleInputChange = e => {
		setSearchQuery(e.target.value);
		const lowerCaseQuery = e.target.value.toLowerCase();
		const filteredModalUsers = modalUsers.filter(user =>
			user.name.toLowerCase().includes(lowerCaseQuery)
		);
		setFilteredUsers(filteredModalUsers);
	};

	const handleUserSelect = (userId, dp, name) => {
		setSelectedUser(userId);
		const obj = {
			isAdmin: `false`,
			user: {
				dp: `${dp}`,
				name: `${name}`,
				_id: `${userId}`,
			},
		};
		setSelectedUserObj(obj);
	};

	const handleEditGrp = () => {
		if (isGrpEdited === true) {
			const filteredModalUsers = allUsers.filter(
				users => !displayedUsersOfGroup.find(u => u.user._id === users._id)
			);
			setModalUsers(filteredModalUsers);
			setFilteredUsers(filteredModalUsers);
		} else {
			const filteredModalUsers = allUsers.filter(
				users => !usersOfParticularGroup.find(u => u.user._id === users._id)
			);
			setModalUsers(filteredModalUsers);
			setFilteredUsers(filteredModalUsers);
		}
		setAddParticipantsModal(true);
	};

	const handleCancel = () => {
		setAddParticipantsModal(false);
		setEditGroupInfoModal(false);
		setModalUsers([]);
		setSelectedUser('');
		setSearchQuery('');
	};

	const handleAddUser = () => {
		if (displayedUsersOfGroup.length === 0) {
			usersOfParticularGroup?.map(users => {
				displayedUsersOfGroup.push(users);
			});
		}
		addUserToGrp();
		setIsGroupEdited(true);
		displayedUsersOfGroup.push(selectedUserObj);
		setAddParticipantsModal(false);
		setSelectedUserObj([]);
		setSelectedUser('');
	};

	const handleRemoveUser = () => {
		if (displayedUsersOfGroup.length === 0) {
			usersOfParticularGroup?.map(users => {
				displayedUsersOfGroup.push(users);
			});
		}
		removeUserFromGrp(selectedUser, false);
		const userRemoved = displayedUsersOfGroup.filter(
			users => !users.user._id.includes(selectedUser)
		);
		setDisplayedUsersOfGroup(userRemoved);
		setIsGroupEdited(true);
	};

	const handleMakeAdmin = () => {
		if (displayedUsersOfGroup.length === 0) {
			usersOfParticularGroup?.map(users => {
				displayedUsersOfGroup.push(users);
			});
		}
		makeGroupAdmin();
		displayedUsersOfGroup[idd].isAdmin = true;
	};

	const handleDismissAdmin = () => {
		if (displayedUsersOfGroup.length === 0) {
			usersOfParticularGroup?.map(users => {
				displayedUsersOfGroup.push(users);
			});
		}
		removeAsAdmin();
		displayedUsersOfGroup[idd].isAdmin = false;
	};

	const handleToggleRedFlagResolution = () => {
		setShowRedFlagResolution(prevState => !prevState);
	};

	const handleEditGroupInfo = () => {
		setEditGroupInfoModal(true);
		console.log(separatedArray);
	};

	const handleGrpInfoModalInputChange = event => {
		const { name, value } = event.target;
		setGroupInfo(prevGroupInfo => ({
			...prevGroupInfo,
			[name]: value,
		}));
	};

	const updateGroupInfo = () => {
		const updatedGroupInfo = `Name: ${groupInfo.userName}--###--Board: [${groupInfo.board}]--###--Standard: [${groupInfo.standard}]--###--Sections: [${groupInfo.sections}]--###--Subject: [${groupInfo.subject}]`;
		let userId = '';
		usersOfParticularGroup?.map(users => {
			if (users.user.role === 'user') {
				userId = users.user._id;
			}
		});
		updateConversationDescription(convId, userId, updatedGroupInfo);
		setEditGroupInfoModal(false);
	};

	const formatMessageTime = time => {
		const utcDateTime = moment.utc(time);
		const istDateTime = utcDateTime
			.utcOffset('+05:30')
			.format('DD/MM/YY, hh:mm A');

		return istDateTime;
	};

	const menu = (
		<Menu>
			<Menu.Item key="1" onClick={handleRemoveUser}>
				Remove User
			</Menu.Item>
			{isAdmin ? (
				<Menu.Item key="3" onClick={handleDismissAdmin}>
					Dismiss As Admin
				</Menu.Item>
			) : (
				<Menu.Item key="2" onClick={handleMakeAdmin}>
					Make Group Admin
				</Menu.Item>
			)}
		</Menu>
	);

	const openFullScreen = imageUrl => {
		setSelectedImage(imageUrl);
		setFullscreenVisible(true);
	};

	const closeFullScreen = () => {
		setSelectedImage('');
		setFullscreenVisible(false);
	};

	return (
		//component for showing the group Information

		<div style={{ height:'100vh', overflowY: 'scroll'}}>
			{showRedFlagResolution && (
				<>
					<RedFlagResolution />
				</>
			)}

			{previewMediaPage && (
				<div>
					<div style={{ backgroundColor: 'rgb(42,57,66)', marginBottom: '15px' }}>
						<button
							className="preview-back-btn"
							onClick={() => {
								setPreviewMediaPage(false);
								setPreviewMediaContent('media');
							}}
						>
							<BiArrowBack />
						</button>
						<div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
							<p
								onClick={() => {
									setPreviewMediaContent('media');
									console.log(mediaCount);
								}}
								style={{
									cursor: 'pointer',
									fontSize: '25px',
									color: `${previewMediaContent == 'media' ? 'green' : '#646F72'}`,
									borderBottom: `${
										previewMediaContent == 'media' ? '3px solid green' : 'none'
									}`,
								}}
							>
								Media
							</p>
							<p
								onClick={() => {
									setPreviewMediaContent('docs');
								}}
								style={{
									cursor: 'pointer',
									fontSize: '25px',
									color: `${previewMediaContent == 'docs' ? 'green' : '#646F72'}`,
									borderBottom: `${
										previewMediaContent == 'docs' ? '3px solid green' : 'none'
									}`,
								}}
							>
								Docs
							</p>
						</div>
					</div>
					<Row gutter={[16, 16]} style={{ margin: '15px' }}>
						{console.log("👩👩",previewMedia)}
						{previewMedia?.map((mediaObject, index) => {
							return mediaObject?.media?.map((media, mediaIndex) => {
								if (media.mediaType === 'image' && previewMediaContent == 'media') {
									mediaCount++;
									return (
										<Col xl={4} lg={6} md={8} sm={12} xs={24} key={mediaIndex}>
											<div
												style={{
													padding: '15px',
													width: '100%',
													height: '200px',
													maxHeight: '200px',
													backgroundColor: 'rgb(42,57,66)',
													overflow: 'hidden',
												}}
											>
												<img
													key={mediaIndex}
													src={media.url}
													alt={`Image ${mediaIndex}`}
													onClick={() => openFullScreen(media.url)}
													className="imageZoom"
													style={{
														width: '100%',
														height: '100%',
														objectFit: 'cover',
														objectPosition: 'center',
													}}
												/>
											</div>
										</Col>
									);
								}
								if (media.mediaType !== 'image' && previewMediaContent == 'docs') {
									docsCount++;
									const urlParts = media.url.split('.');
									const extension = urlParts[urlParts.length - 1].toLowerCase();
									const nameparts = media.url.split('/');
									const nameoffile = nameparts[nameparts.length - 1];
									return (
										<Col xl={8} lg={12} md={24} sm={24} span={4} key={mediaIndex}>
											<div
												style={{
													padding: '15px',
													width: '100%',
													height: '100px',
													maxHeight: '100px',
													backgroundColor: 'rgb(42,57,66)',
													overflow: 'hidden',
												}}
											>
												<a href={`${media.url}`} style={{ textDecoration: 'none' }}>
													<div style={{ cursor: 'pointer', marginRight: '0' }}>
														<div style={{ padding: '5px' }}>
															{/* <GrDocumentUpdate
																size={30}
																style={{ color: 'white', margin: '5px' }}
															/> */}
															<img src={doc} style={{ width: '9%', paddingRight: '5px' }} />
															<span style={{ color: 'white', marginLeft: '30px' }}>
																{nameoffile}
															</span>
															<span>
																<BsDownload
																	size={15}
																	style={{ color: 'white', marginLeft: '15px' }}
																/>
															</span>
														</div>
													</div>
												</a>
											</div>
										</Col>
									);
								}
								return null;
							});
						})}
					</Row>
					{previewMediaContent == 'media' && mediaCount == 0 && (
						<p
							style={{
								color: 'white',
								textAlign: 'center',
								fontSize: '1.25rem',
								marginTop: '15px',
							}}
						>
							No Media found
						</p>
					)}
					{previewMediaContent == 'docs' && docsCount == 0 && (
						<p
							style={{
								color: 'white',
								textAlign: 'center',
								fontSize: '1.25rem',
								marginTop: '15px',
							}}
						>
							No Documents found
						</p>
					)}
				</div>
			)}

			{!showRedFlagResolution && !previewMediaPage && (
				<>
					<div
						className="contact-navbar p-3"
						style={{
							backgroundColor: '#111A21',
							border: '1px',
							borderRightColor: 'white',
							border: '1px solid',
							cursor: 'default',
						}}
					>
						{/* Contact info */}
						<div className="contact-info">
							<button className="back-btn" onClick={handletoggle}>
								<BiArrowBack />
							</button>
							{/* Profile picture */}
							<img className="profile-pic" src={pimgLink} alt="profile_picture" />

							{/* Info */}
							<div className="contact-details">
								{/* Contact */}
								<h6 className="contact-name">{namePerson}</h6>

								{/* Status */}
								<p className="contact-status"></p>
							</div>
						</div>
					</div>
					{/* userimage and it's name */}
					<div
						style={{
							textAlign: 'center',
							display: 'flex',
							justifyContent: 'center',
							flexDirection: 'column',
							alignItems: 'center',
							marginTop: '50px',
						}}
					>
						{/* <ProfilePic convId={convId} isProfile={false} initialDp={pimgLink} /> */}
						<h6 style={{ color: 'gray', marginTop: '10px' }}>
							{isGrpEdited
								? displayedUsersOfGroup.length
								: usersOfParticularGroup.length}{' '}
							Participants
						</h6>

						{/* Name of thev user */}
						<h3 style={{ color: 'white' }} className="pt-3">
							{namePerson}
						</h3>
					</div>
					{/* Description of the particular sudent and group information  */}
					<div className="description">
						<div className="container" style={{ width: '70%' }}>
							<div className="dark-container" style={{ textAlign: 'center' }}>
								<div className="dark-group-description">
									<p className="dark-description-text">{separatedArray[0]}</p>
									<p className="dark-description-text">{separatedArray[1]}</p>
									<p className="dark-description-text">{separatedArray[2]}</p>
									<p className="dark-description-text">{separatedArray[3]}</p>
									<p className="dark-description-text">{separatedArray[4]}</p>
								</div>
							</div>

							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
									marginTop: '20px',
									alignItems: 'center',
									flexDirection: 'column',
									fontSize: '15px',
								}}
							>
								{user.role !== 'user' && user.role !== 'parent' && (
									<Button style={{ marginBottom: '15px' }} onClick={handleEditGroupInfo}>
										Edit Group Info
									</Button>
								)}
								<Button onClick={handleToggleRedFlagResolution}>
									Show Red Flag Resolution History
								</Button>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										color: 'white',
										marginTop: '20px',
									}}
								>
									{user._id == createdBy._id ? (
										<p style={{ marginBottom: '0' }}>
											<span style={{ fontWeight: 'bolder' }}>Created By: </span>You (
											{formatMessageTime(createdAt)})
										</p>
									) : (
										<p style={{ marginBottom: '0' }}>
											<span style={{ fontWeight: 'bolder' }}>Created By: </span>
											{createdBy.name} ({formatMessageTime(createdAt)})
										</p>
									)}
								</div>
							</div>

							<div className="mainMedia">
								<div
									className="mediaFolder"
									style={{ cursor: 'pointer' }}
									onClick={() => {
										setPreviewMediaPage(true);
									}}
								>
									<div>
										<p style={{ marginBottom: '0' }}>Media and Docs</p>
									</div>
									<div>
										<AiOutlineRight />
									</div>
								</div>
								<div className="imgbox">
									<Row style={{ justifyContent: 'center' }} gutter={[16, 16]}>
										{previewMedia.length !== 0 && (
											<>
												{(() => {
													let count = 0;
													return previewMedia?.map((mediaObject, index) =>
														mediaObject?.media?.map((media, mediaIndex) => {
															if (media?.mediaType === 'image' && count < 3) {
																count++;
																return (
																	<Col span={8} key={mediaIndex}>
																		<div
																			style={{
																				padding: '15px',
																				width: '100%',
																				height: '150px',
																				maxHeight: '150px',
																				backgroundColor: 'rgb(42,57,66)',
																				overflow: 'hidden',
																				borderRadius: '3px',
																			}}
																		>
																			<img
																				key={mediaIndex}
																				src={media.url}
																				alt={`Image ${mediaIndex}`}
																				onClick={() => openFullScreen(media.url)}
																				className="imageZoom"
																				style={{
																					width: '100%',
																					height: '100%',
																					objectFit: 'cover',
																					objectPosition: 'center',
																				}}
																			/>
																		</div>
																	</Col>
																);
															}
															return null;
														})
													);
												})()}
											</>
										)}
									</Row>
								</div>
							</div>

							<h6
								className="py-2"
								style={{
									color: 'white',
									// marginTop: '25px',
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
								}}
							>
								Participants:
								{user.role == 'moderator' && (
									<div className="py-2">
										<Button onClick={handleEditGrp}>Add Participants</Button>
									</div>
								)}
							</h6>

							<div
								style={{
									backgroundColor: '#111A21',
									borderRadius: '10px',
									padding: '10px',
								}}
							>
								{isGrpEdited === true
									? displayedUsersOfGroup?.map((users, i) => {
											return (
												<div className="group-users-container">
													{
														<div
															key={i}
															style={{
																display: 'flex',
																justifyContent: 'space-between',
																alignItems: 'center',
															}}
														>
															<div className={`group-users`}>
																<img
																	className="profile-pic"
																	src={
																		users.user.dp === ''
																			? 'https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/6471ec801d1a71103fc8f669/UKVqGegFg8.svg'
																			: users.user.dp
																	}
																	alt="profile_picture"
																/>
																{/* {users.user._id == user._id ? (
																<h6 className="contact-name">You</h6>
															) : (
																<h6 className="contact-name">{users.user.name}</h6>
															)}
															<h6
																className="contact-name"
																style={{ display: 'flex', flexDirection: 'column' }}
															>
																{user.user.name && user.user.name}
																{user.user.post ? (
																	<p
																		style={{ fontSize: '15px', color: 'grey', marginTop: '5px' }}
																	>
																		{user.user.post}
																	</p>
																) : (
																	<p
																		style={{ fontSize: '15px', color: 'grey', marginTop: '5px' }}
																	>
																		{user.user.role == 'user' ? 'Student' : user.user.role}
																	</p>
																)}
															</h6> */}
																<h6
																	className="contact-name"
																	style={{ display: 'flex', flexDirection: 'column' }}
																>
																	{users.user._id == user._id ? (
																		<h6 className="contact-name">You</h6>
																	) : (
																		<h6 className="contact-name">{users.user.name}</h6>
																	)}
																	{users.user.post ? (
																		<p
																			style={{ fontSize: '15px', color: 'grey', marginTop: '5px' }}
																		>
																			{users.user.post}
																		</p>
																	) : (
																		<p
																			style={{ fontSize: '15px', color: 'grey', marginTop: '5px' }}
																		>
																			{users.user.role == 'user' ? 'Student' : users.user.role}
																		</p>
																	)}
																</h6>
															</div>

															<div style={{ display: 'flex' }}>
																{users.isAdmin === true && (
																	<div style={{ display: 'flex' }}>
																		<p
																			className="contact-name"
																			style={{
																				color: '#fff',
																				marginRight: '10px',
																				fontSize: '15px',
																			}}
																		>
																			Group Admin
																		</p>
																	</div>
																)}
																{users.user._id != user._id && user.role == 'moderator' && (
																	<div
																		className="edit-group-btn"
																		style={{ marginRight: '20px' }}
																		onClick={() => {
																			setSelectedUser(users.user._id);
																			setIdd(i);
																		}}
																	>
																		<Dropdown overlay={menu} trigger={['click']}>
																			<a
																				className="ant-dropdown-link"
																				onClick={e => {
																					e.preventDefault();
																					if (users.isAdmin) {
																						setIsAdmin(true);
																					} else {
																						setIsAdmin(false);
																					}
																				}}
																			>
																				<DownOutlined />
																			</a>
																		</Dropdown>
																	</div>
																)}
															</div>
														</div>
													}
												</div>
											);
											return null;
									  })
									: usersOfParticularGroup?.map((users, i) => {
											return (
												<div className="group-users-container">
													{
														<div
															key={i}
															style={{
																display: 'flex',
																justifyContent: 'space-between',
																alignItems: 'center',
															}}
														>
															<div className={`group-users`}>
																<img
																	className="profile-pic"
																	src={
																		users.user.dp === ''
																			? 'https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/6471ec801d1a71103fc8f669/UKVqGegFg8.svg'
																			: users.user.dp
																	}
																	alt="profile_picture"
																/>
																<h6
																	className="contact-name"
																	style={{ display: 'flex', flexDirection: 'column' }}
																>
																	{users.user._id == user._id ? (
																		<h6 className="contact-name">You</h6>
																	) : (
																		<h6 className="contact-name">{users.user.name}</h6>
																	)}
																	{users.user.post ? (
																		<p
																			style={{ fontSize: '15px', color: 'grey', marginTop: '5px' }}
																		>
																			{users.user.post}
																		</p>
																	) : (
																		<p
																			style={{ fontSize: '15px', color: 'grey', marginTop: '5px' }}
																		>
																			{users.user.role == 'user' ? 'Student' : users.user.role}
																		</p>
																	)}
																</h6>
															</div>
															<div style={{ textAlign: 'end' }}>
																<div style={{ paddingRight: '10px', paddingBottom: '8px' }}>
																	<a href={`tel:${users.user.mobileNumber}`}>
																		<BsTelephonePlusFill style={{ color: 'white' }} />{' '}
																	</a>
																</div>
																<div style={{ display: 'flex' }}>
																	{users.isAdmin === true && (
																		<p
																			className="contact-name"
																			style={{
																				color: '#fff',
																				marginRight: '10px',
																				fontSize: '15px',
																			}}
																			onClick={() => {
																				console.log(user);
																			}}
																		>
																			Group Admin
																		</p>
																	)}
																	{users.user._id != user._id && user.role == 'moderator' && (
																		<div
																			className="edit-group-btn"
																			style={{ marginRight: '20px' }}
																			onClick={() => {
																				setSelectedUser(users.user._id);
																				setIdd(i);
																			}}
																		>
																			<Dropdown overlay={menu} trigger={['click']}>
																				<a
																					className="ant-dropdown-link"
																					style={{ color: 'white' }}
																					onClick={e => {
																						e.preventDefault();
																						if (users.isAdmin) {
																							setIsAdmin(true);
																						} else {
																							setIsAdmin(false);
																						}
																					}}
																				>
																					<DownOutlined />
																				</a>
																			</Dropdown>
																		</div>
																	)}
																</div>
															</div>
														</div>
													}
												</div>
											);
											return null;
									  })}
							</div>
							<div style={{ textAlign: 'center', marginTop: '10px' }}>
								{user.role !== 'user' && user.role !== 'parent' && (
									<div className="py-2">
										<Button
											onClick={() => {
												removeUserFromGrp(user._id, true);
											}}
										>
											Exit Group
										</Button>
									</div>
								)}
							</div>
						</div>
					</div>

					<Modal
						title="Edit Group"
						visible={addParticipantsModal}
						onCancel={handleCancel}
						footer={null}
						bodyStyle={{
							maxHeight: '550px',
							overflow: 'auto',
							paddingTop: '0',
							paddingBottom: '0',
						}}
					>
						<div className="edit-shortcut-modal">
							<div className="search-bar">
								<Input
									type="text"
									value={searchQuery}
									onChange={handleInputChange}
									placeholder="Search Users"
									className="modal-input-bar"
								/>
							</div>

							<div className="modal-users-container">
								{filteredUsers.length !== 0 ? (
									filteredUsers?.map(user => {
										const isSelected = selectedUser.includes(user._id);
										return (
											<div
												key={user._id}
												onClick={() => handleUserSelect(user._id, user.dp, user.name)}
												className={`modal-conversations`}
												style={{ backgroundColor: isSelected ? '#202d33' : '' }}
											>
												<img
													className="profile-pic"
													src={
														user.dp === ''
															? 'https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/6471ec801d1a71103fc8f669/UKVqGegFg8.svg'
															: user.dp
													}
													alt="profile_picture"
												/>
												<h6 className="contact-name">{user.name}</h6>
											</div>
										);
									})
								) : (
									<h5 className="no-users" style={{ color: 'white' }}>
										No Users Found
									</h5>
								)}
							</div>

							<div className="modal-btn-container">
								<Button onClick={handleCancel} style={{ marginRight: '20px' }}>
									Cancel
								</Button>
								<Button
									type="primary"
									disabled={selectedUser.length === 0}
									onClick={handleAddUser}
								>
									Add
								</Button>
							</div>
						</div>
					</Modal>

					<Modal
						title="Edit Group"
						visible={editGrpInfoModal}
						onCancel={handleCancel}
						footer={null}
						bodyStyle={{
							maxHeight: '550px',
							overflow: 'auto',
							paddingTop: '0',
							paddingBottom: '0',
						}}
					>
						<div style={{ textAlign: 'center' }}>
							<div>
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										textAlign: 'center',
										marginTop: '10px',
									}}
								>
									<h6>Unique Code: {groupInfo.uniqueCode}</h6>
								</div>

								<div className="group-info-modal">
									<p>Name: </p>
									<input
										type="text"
										name="userName"
										style={{ color: 'black' }}
										value={groupInfo.userName}
										onChange={handleGrpInfoModalInputChange}
									/>
								</div>

								<div className="group-info-modal">
									<p>Board: </p>
									<input
										type="text"
										name="board"
										style={{ color: 'black' }}
										value={groupInfo.board}
										onChange={handleGrpInfoModalInputChange}
									/>
								</div>

								<div className="group-info-modal">
									<p>Standard: </p>
									<input
										type="text"
										name="standard"
										style={{ color: 'black' }}
										value={groupInfo.standard}
										onChange={handleGrpInfoModalInputChange}
									/>
								</div>

								<div className="group-info-modal">
									<p>Sections: </p>
									<input
										type="text"
										name="sections"
										style={{ color: 'black' }}
										value={groupInfo.sections}
										onChange={handleGrpInfoModalInputChange}
									/>
								</div>
							</div>
						</div>

						<div className="modal-btn-container">
							<Button onClick={handleCancel} style={{ marginRight: '20px' }}>
								Cancel
							</Button>
							<Button type="primary" onClick={updateGroupInfo}>
								Update
							</Button>
						</div>
					</Modal>
				</>
			)}

			<Modal
				open={fullscreenVisible}
				footer={null}
				onCancel={closeFullScreen}
				closable={false}
				width="auto"
				className="fullscreen-modal"
				centered
			>
				<Tooltip title="Click here to download" placement="right">
					<a href={selectedImage} style={{ textDecoration: 'none', color: 'black' }}>
						<FaDownload size={20} style={{ cursor: 'pointer' }} />
					</a>
				</Tooltip>

				<div
					className="fullscreen-image-container"
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '60vh',
						width: '60vh',
						margin: '0 auto',
					}}
				>
					<Image
						src={selectedImage}
						preview={false}
						centered
						alt="Fullscreen Image"
						style={{ maxHeight: '80%', maxWidth: '80%', objectFit: 'contain' }}
					/>
				</div>
			</Modal>
		</div>
	);
};

export default Groupinformation;
